module.exports = __webpack_public_path__ + "static/media/analysis.d80d5b18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/analysis.svg
// module id = 258
// module chunks = 0